import React, { useRef } from 'react';
import { useImages } from '../context/ImageContext';
import BoardCardTip from './BoardCardTip';
import { IsMobile, useHover } from '../utils/Mobile';
const TechnologyConverter = require('@tta/engine/Utilities/Converters/TechnologyConverter');
const { GameColors } = require('./Constants/Constants')
const { ShownName } = require('@tta/engine/Utilities/ShownNames');

// Color and image lookups are keyed without spaces ("Air Forces" -> "AirForces")
const typeKey = (type) => type.replace(/\s/g, '');

// One cell of the building grid: the card name, a worker icon per worker on it and its food/resource tokens.
// Empty cells (no card of that type and age) are dark, like BGO's.
// Selection: while moving a worker (Freedom of Movement), whether this card can be clicked and whether it is where from or
// where to ({ selectable, reason?, mark? }); OnClick then picks it. With the action bar's trigger on, target: its key (the
// popup by the mouse says what picking it would do, in place of the card's hover). OnUpgrade: with nothing being picked
// (static buttons), a card that can be upgraded is clicked to start upgrading it
function TechnologySquare({Technology, Selection, OnClick, OnUpgrade})
{
    const { images } = useImages();
    // (on a phone, a tap shows the card, and picks it too while moving a worker)
    const [hover, , hoverProps] = useHover({ Closes: true });
    const cellRef = useRef(null);

    if (Technology === undefined){
        return (<td className="tta-building-cell tta-building-empty"></td>)
    }

    const type = Technology.technology.type;
    // Types without their own icon fall back to a yellow worker token
    const workerImage = (images[typeKey(type)] ?? images.YellowCube).src;
    const tokenImage = images[type === "Farm" ? "Food" : "Resource"].src;

    const workerCount = Technology.contents?.workers ?? 0;
    const blueCubeCount = Technology.contents?.blueCubes ?? 0;

    return (
        <td className={`tta-building-cell${Selection ? ` tta-board-${Selection.selectable ? 'selectable' : 'blocked'}${Selection.mark ? ` tta-board-${Selection.mark}` : ''}` : ''}${!Selection && OnUpgrade ? ' tta-board-upgradable' : ''}`}
            style={{ backgroundColor: GameColors.TechnologyBackgroundColors[typeKey(type)] }}
            ref={cellRef} {...hoverProps} data-tta-target={Selection?.target}
            onClick={IsMobile ? () => { hoverProps.onClick(); Selection?.selectable && OnClick(Technology.name); }
                : Selection?.selectable ? () => OnClick(Technology.name)
                : !Selection && OnUpgrade ? () => OnUpgrade(Technology.name) : undefined}>
            {/* On hover: the card, what other cards change about it (and, while moving a worker, why it can't be picked) */}
            <BoardCardTip card={TechnologyConverter(Technology.name)} target={cellRef.current} show={hover && !Selection?.target} note={Selection?.reason}
                cost={Technology.cost} perWorker={Technology.perWorker} changedBy={Technology.changedBy}/>
            <div className="tta-building-name">{ShownName(Technology.name)}</div>
            <div className="tta-building-workers">
                {Array.from({length: workerCount}).map((_, index) =>
                    <img key={index} src={workerImage} alt={type}/>)}
            </div>
            <div className="tta-building-tokens">
                {Array.from({length: blueCubeCount}).map((_, index) =>
                    <img key={index} src={tokenImage} alt=""/>)}
            </div>
        </td>
    );
}

export default TechnologySquare;